import React from "react";
import Layout from "../Layout/Layout";

const MoviesPage = () => {
  return (
    <Layout>
      <div></div>
    </Layout>
  );
};

export default MoviesPage;
